import React, { useState, useEffect } from "react";
import {Button, TextField } from "@mui/material";
import * as sweetalert from "sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useFormupdate } from "./useFormupdate";
import {
  Grid
} from "@material-ui/core";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function Billpercentage() {
  const { id } = useParams();

  const navigate = useNavigate();
  const [fund, setfund] = useState([]);
  const [formValues, setFormValues] = useState({


    discount_for_client: "",
    discount_for_special_distributor: "",
    discount_for_general_distributor: "",
    profit_for_client: "",
    profit_for_special_distributor: "",
    profit_for_general_distributor: "",
  

  });
  const initialFValues = {

    discount_for_client: "",
    discount_for_special_distributor: "",
    discount_for_general_distributor: "",
    profit_for_client: "",
    profit_for_special_distributor: "",
    profit_for_general_distributor: "",


  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("price_for_general_distributor" in fieldValues) {

      if (fieldValues.price_for_general_distributor > 1) {

        temp.price_for_general_distributor = "يحب أن تكون القيمة بين 0 و 1";
      }
      else {
        temp.price_for_general_distributor = "";

      }
    }

    if ("price_for_special_distributor" in fieldValues) {

      if (fieldValues.price_for_special_distributor > 1) {

        temp.price_for_special_distributor = "يحب أن تكون القيمة بين 0 و 1";
      }
      else {
        temp.price_for_special_distributor = "";

      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    errors,
    setErrors,

  } = useFormupdate(initialFValues, true, validate);

  const handleChange = (e) => {
    e.persist();
   
    if ( e.target.value < 1 && e.target.value >= 0) {
      setFormValues({ ...formValues, [e.target.name]: e.target.value });

    } else {
      sweetalert("يجب أن يكون الر قم بين الصفر و الواحد ");
    }



  };

  useEffect(() => {

    axios
      .get(`${BaseUrl}/api/getpriceByID/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
       
        setFormValues({
          ...formValues,
    

          discount_for_client: res.data.data.fundprices[0].discount_for_client,

          discount_for_special_distributor: res.data.data.fundprices[0].discount_for_special_distributor,

          discount_for_general_distributor: res.data.data.fundprices[0].discount_for_general_distributor,

          profit_for_client: res.data.data.fundprices[0].profit_for_client,

          profit_for_special_distributor: res.data.data.fundprices[0].profit_for_special_distributor,

          profit_for_general_distributor: res.data.data.fundprices[0].profit_for_general_distributor,


        });
      

      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {

      discount_for_client: formValues.discount_for_client,
      discount_for_special_distributor: formValues.discount_for_special_distributor,
      discount_for_general_distributor: formValues.discount_for_general_distributor,
      profit_for_client: formValues.profit_for_client,
      profit_for_special_distributor: formValues.profit_for_special_distributor,
      profit_for_general_distributor: formValues.profit_for_general_distributor,
      

    };

    axios
      .post(`${BaseUrl}/api/addpriceTofund/${id}`, data, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.data.status === true) {
          sweetalert("تم التعديل بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          navigate("/getfund");
        } else {
          sweetalert("خطأ في عملية التعديل", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          setFormValues({ ...formValues, error_list: res.data.error });
        }
      });
  };

  return (
    <div className="main-div">
      <h3 className="titlepage">تعديل نسبة</h3>

      <form
        className="form-group"
        method="post"
        enctype="multipart/form-data"
        noValidate
        onSubmit={handleSubmit}
      >
        <div className="form-group">
          <Grid container maxWidth="sm" spacing={4}>
            

            <Grid item md={3} xs={12}>
              <TextField
                placeholder="خصم الزبون"
                className="form-control"
                label="خصم الزبون"
                name="discount_for_client"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.discount_for_client}
                onChange={handleChange}
                error={formValues.discount_for_client.error}
                helperText={
                  formValues.discount_for_client.error &&
                  formValues.discount_for_client.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="خصم الموزع الخاص"
                className="form-control"
                label="خصم الموزع الخاص"
                name="discount_for_special_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.discount_for_special_distributor}
                onChange={handleChange}
                error={formValues.discount_for_special_distributor.error}
                helperText={
                  formValues.discount_for_special_distributor.error &&
                  formValues.discount_for_special_distributor.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="خصم الموزع العام"
                className="form-control"
                label="خصم الموزع العام"
                name="discount_for_general_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.discount_for_general_distributor}
                onChange={handleChange}
                error={formValues.discount_for_general_distributor.error}
                helperText={
                  formValues.discount_for_general_distributor.error &&
                  formValues.discount_for_general_distributor.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح الزبون"
                className="form-control"
                label="ربح الزبون"
                name="profit_for_client"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_for_client}
                onChange={handleChange}
                error={formValues.profit_for_client.error}
                helperText={
                  formValues.profit_for_client.error &&
                  formValues.profit_for_client.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح الموزع الخاص"
                className="form-control"
                label="ربح الموزع الخاص"
                name="profit_for_special_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_for_special_distributor}
                onChange={handleChange}
                error={formValues.profit_for_special_distributor.error}
                helperText={
                  formValues.profit_for_special_distributor.error &&
                  formValues.profit_for_special_distributor.errorMessage
                }
              />
            </Grid>
            <Grid item md={3} xs={12}>
              <TextField
                placeholder="ربح الموزع العام"
                className="form-control"
                label="ربح الموزع العام"
                name="profit_for_general_distributor"
                fullWidth
                type="text"
                InputProps={{ inputProps: { min: 0, max: 1 } }}
                value={formValues.profit_for_general_distributor}
                onChange={handleChange}
                error={formValues.profit_for_general_distributor.error}
                helperText={
                  formValues.profit_for_general_distributor.error &&
                  formValues.profit_for_general_distributor.errorMessage
                }
              />
            </Grid>
  
          </Grid>
        </div>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Button
            type="submit"
            variant="contained"
            className="btn-submit"
            color="secondary"
          >
            حفظ
          </Button>
        </Grid>
      </form>
    </div>
  );
}

